export default {"src":"/_next/static/media/light-purple-to-light-blue-left.05dbb2ce.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};